import { useSelector } from 'react-redux';
import { RootState } from '../redux/reducers/rootReducer';

/**
 * Custom hook to get resources for the current language
 * Language sync is handled globally in App.tsx via useLanguageSync
 * 
 * @param resources - The resource object containing translations
 * @returns The resource object for the current language with fallback to English
 */
export const useResources = <T>(resources: Record<string, T>): T => {
  const language = useSelector((state: RootState) => state.language);
  return resources[language] || resources.en;
};